import React from 'react';

import TableListProductMapping from '@pages/UploadMappingV2/components/Table/TableListProductMapping';
import { useMassalStore } from '@pages/UploadMappingV2/hooks/state/useAddProductMassal';
import { tableHeadLists } from './const';
import EmptyState from '@pages/UploadMappingV2/components/ui/EmptyState';
import { EmptyStateProductMapping } from '@pages/UploadMappingV2/assets/images';

export default function ProductSatuan() {
    const { pieces } = useMassalStore();

    const renderContent =
        pieces.length > 0 ? (
            <TableListProductMapping isPagination tableHeadLists={tableHeadLists} tableData={pieces} data={pieces} />
        ) : (
            <EmptyState
                title="Tidak Ada Produk Untuk Di-mapping"
                description="Anda dapat melanjutkan ke proses berikutnya."
                Image={EmptyStateProductMapping}
            />
        );

    return renderContent;
}
